import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { NumberTicker } from './ui/number-ticker';

const metrics = [
  { value: 50, suffix: '+', label: 'AI Workflows Deployed' },
  { value: 5,  suffix: '+', label: 'Countries Served' },
  { value: 10, suffix: 'x', label: 'Average Efficiency Lift' },
  { value: 11, suffix: '+', label: 'Years connecting technology, process & people' },
];

const MetricsBar = () => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <div
      ref={ref}
      className={`mt-10 lg:mt-12 transition-all duration-700 ease-out ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      }`}
    >
      <div className="soft-card hero-stats-shell rounded-2xl px-4 sm:px-6 py-5 sm:py-6">
        <div className="hero-stats-grid">
          {metrics.map((metric, index) => (
            <article
              key={metric.label}
              className={`hero-stat-item transition-all duration-700 ease-out ${
                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
              }`}
              style={{ transitionDelay: `${index * 120}ms` }}
            >
              <p className="hero-stat-value">
                <NumberTicker
                  value={metric.value}
                  start={isVisible}
                  delay={0.2 + index * 0.15}
                  duration={2800}
                />
                <span className="hero-stat-suffix">{metric.suffix}</span>
              </p>
              <p className="hero-stat-label">{metric.label}</p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MetricsBar;
